import { alpha, Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton, SuccessButton } from "..";
import { useStripe, useElements, CardElement, loadStripe, Elements } from "@stripe/react-stripe-js";
import { useState } from "react";
import { config } from "../../utils/config";


export default function PaymentMethodModal(props) {
    const { open, onClose, onFinish, currentPlan, cardClientSecret, billing_details } = props;

    const { mode } = useColorScheme();
    const currentMode = mode || "system";
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 360,
        maxWidth: 550,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[currentMode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    }

    const cardStyle = {
        style: {
            base: {
                color: "#32325d",
                fontFamily: "Arial, sans-serif",
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#32325d",
                },
            },
            invalid: {
                fontFamily: "Arial, sans-serif",
                color: "#fa755a",
                iconColor: "#fa755a",
            },
        },
    };

    const stripe = useStripe();
    const elements = useElements();
    const [cardError, setCardError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleCardChange = async (event) => {
        setCardError(event.error ? event.error.message : "");
        console.log(event?.error?.message);
    };

    const submitCard = () => {
        return new Promise((resolve, reject) => {
          stripe
            .confirmCardSetup(cardClientSecret, {
              payment_method: {
                card: elements.getElement(CardElement),
                billing_details: billing_details,
              },
            })
            .then(function (result) {
              if (result.error) {
                reject(result.error.message);
              } else {
                resolve(result);
              }
            });
        });
      };

    const onSubmit = async () => {
        if (cardError) {
            return;
        }

        try {
              setSubmitting(true);
              const resp = await submitCard();
              const paymentMethod = resp.setupIntent["payment_method"];
              onFinish(paymentMethod);
              
            } catch (e) {
        
            }
            setSubmitting(false);
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-payment-plans-title"
            aria-describedby="modal-payment-plans-description"
        >
            <Box sx={style}>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Payment Method
                </Typography>
                <Typography
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.medium,
                        fontSize: Constants.Styles.fontSize.sm,
                        lineHeight: Constants.Styles.lineHeight.sm,
                        mt: "1.5rem",
                        mb: "1.125rem",
                    }}
                >
                    Enter your credit card info. A total amount of ${currentPlan?.price} will be charged for your selected plan - {currentPlan.plan}.
                </Typography>
                <Stack
                spacing={"1.5rem"}
                >
                    <CardElement
                        options={cardStyle}
                        onChange={handleCardChange}
                    ></CardElement>
                    {cardError && (
                        <Typography
                            sx={{
                                color: Constants.Colors[currentMode].destructive,
                                fontSize: Constants.Styles.fontSize.sm,
                                lineHeight: Constants.Styles.lineHeight.sm,
                            }}
                        >
                            {cardError}
                        </Typography>
                    )}
                    <Stack direction={"row"} alignItems={"center"} justifyContent={"end"} spacing={2} sx={{
                        mt: "2rem",
                    }}>
                        <DefaultButton
                            text={"Cancel"}
                            onClick={onClose}
                            size="medium"
                            sx={{
                                width: 60,
                            }}
                        />
                        <SuccessButton
                            text={"Save Card & Make a Payment"}
                            size="medium"
                            sx={{
                                width: 240,
                            }}
                            onClick={() => {
                                onSubmit();
                            }}
                        />
                    </Stack>
                </Stack>
            </Box>
        </Modal>
    );
}